/* eslint-disable @typescript-eslint/no-namespace */

export namespace Viewing {
  export namespace Extensions {
    export const TOTALCO2_INITIALIZED_EVENT: string = "totalCo2Initialized";
    export const TOTALCO2_UNINITIALIZED_EVENT: string = "totalCo2Uninitialized";
    export const TOTALCO2_SELECTION_CHANGED_EVENT: string = "totalCo2Selection";
    export const TOTALCO2_PANEL_OPENED_EVENT: string = "totalCo2PanelOpened";
  }
}
